import cx from 'classnames';
import * as React from 'react';

import Link from '../../link/link';

import './logo_type_simple.scss';

const PARAGRAPH_SVG =
    'M13.34 12.997v-.074c.02-.056.038-.093.057-.167.17-.409.455-1.133.701-1.84.152-.408.284-.817.398-1.17.095-.334.17-.65.17-.836a.638.638 0 00-.189-.464c-.133-.112-.303-.168-.492-.205-1.08-.13-2.218-.353-3.07-.817-.853-.446-1.403-1.096-1.403-2.081 0-.539.171-1.003.474-1.32.303-.315.74-.52 1.327-.52.833 0 1.175.41 1.175.688 0 .056-.02.111-.076.186-.038.056-.095.111-.152.186-.019.018-.038.055-.057.074-.17.204-.379.483-.379.892 0 .669.55 1.189 1.289 1.189.436 0 .834-.167 1.099-.483.265-.316.417-.743.417-1.264 0-1.486-1.497-2.526-3.278-2.526-2.331 0-3.923 1.672-3.923 3.734 0 1.208.436 2.136 1.213 2.805.038.019.038.037.038.037s0 .038-.02.112a.653.653 0 01-.075.167c-.17.427-.455 1.152-.701 1.84-.152.408-.284.798-.38 1.133-.094.334-.17.632-.17.817 0 .168.057.335.19.465.132.111.303.167.492.204 1.08.13 2.218.353 3.07.818.853.446 1.402 1.096 1.402 2.08 0 .54-.17 1.004-.473 1.32-.303.315-.74.52-1.327.52-.833 0-1.175-.409-1.175-.688 0-.056.02-.111.076-.186.038-.055.095-.111.152-.185.019-.019.038-.056.057-.075.17-.204.379-.483.379-.891 0-.67-.55-1.19-1.289-1.19-.436 0-.834.168-1.099.484-.265.315-.417.743-.417 1.263 0 1.486 1.497 2.527 3.278 2.527 2.331 0 3.923-1.672 3.923-3.735.019-1.207-.436-2.136-1.232-2.824zm-.398-2.545c-.19.576-.568 1.468-.758 1.877-.833-.372-1.743-.614-2.88-.67-.076 0-.133-.018-.17-.018 0-.018 0-.037.018-.056.19-.576.569-1.467.758-1.895.834.372 1.744.613 2.862.688.075 0 .132.018.17.018v.056z';

type Props = React.SVGProps<SVGSVGElement> & {
    to?: string;
    isRouter?: boolean;
    withoutLink?: boolean;
};

const LogoTypeSimple = ({
    className,
    isRouter,
    to,
    withoutLink = false,
    ['aria-label']: ariaLabel,
    ...svgProps
}: Props) => {
    return (
        <Link
            aria-label={ariaLabel}
            className={cx(className, 'logo__simple-background')}
            isRouter={isRouter}
            pseudo={withoutLink}
            to={to || '/'}
        >
            <svg fill="none" focusable="false" height="1em" viewBox="0 0 22 22" width="1em" {...svgProps}>
                <path d={PARAGRAPH_SVG} fill="#000" />
            </svg>
        </Link>
    );
};

export default LogoTypeSimple;
